// generated file, if you want to edit this file manually change the word "generated" to "manual"
import React from "react";
import clsx from "clsx";
import { makeThemedStyles } from "./../utils";
import MaterialMenuList from "@material-ui/core/MenuList";
import { excludeKeys } from "./../utils";
const useStylesForKPIDetailsMenuList = makeThemedStyles(
  "KPIDetailsContent.KPIDetailsMenuList",
  (theme) => ({
    KPIDetailsMenuList: {},
  })
);
type PropType = React.ComponentProps<typeof MaterialMenuList>;
export const KPIDetailsMenuList: React.FunctionComponent<PropType> = (
  props: PropType
) => {
  const styles = useStylesForKPIDetailsMenuList();
  const enabledClasses = excludeKeys(styles, ["KPIDetailsMenuList"]);
  /* eslint-disable */
  return (
    <MaterialMenuList
      {...props}
      classes={{
        root: styles.KPIDetailsMenuList,
        ...enabledClasses,
      }}
      className={clsx(styles.KPIDetailsMenuList)}
    >
      {props?.children}
    </MaterialMenuList>
  );
};
export default KPIDetailsMenuList;
